import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { useNotificationDropdown } from "./NotificationDropdownHook";
import { SignalRContext } from "app/AppContext";
//i18n
import { useTranslation, withTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { formatDateTimeFromNow } from "helpers/date-time";
import classNames from "classnames";
import "./NotificationDropdown.scss";
import { Switch } from "antd";
import Email24 from "@carbon/icons-react/es/email/24";
import EmailNew16 from "@carbon/icons-react/es/email--new/16";
import Launch16 from "@carbon/icons-react/es/launch/16";
import "moment/locale/vi";
import { buildAbsoluteLink } from "helpers/string";
import { Button } from "react3l-ui-library";

export const SIGNALR_CHANNEL: string = "Receive";

const NotificationDropdown = (props: any) => {
  const [translate] = useTranslation();

  const signalRContext = useContext(SignalRContext);
  const {
    showUnread,
    handleToggleNotification,
    notificationDropDown,
    notifications,
    hasMore,
    total,
    loadingNotification,
    handleClickToNotification,
    handleInfiniteOnLoad,
    handleMouseLeaveAll,
    handleReadNotification,
    unreadNotification,
    handleMouseEnterNotification,
    handleMouseLeaveNotification,
    handleUnReadNotification,
    handleClickReadAllNotification,
    handleChangeUnreadSwitch,
  } = useNotificationDropdown(signalRContext, SIGNALR_CHANNEL);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={notificationDropDown}
        toggle={handleToggleNotification}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn btn-48 header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
          onClick={handleToggleNotification}
        >
          <svg className={"top-nav-btn"} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M24.7273 13.7331V11.5198C24.7273 9.17181 23.8078 6.91998 22.1711 5.2597C20.5344 3.59942 18.3146 2.66669 16 2.66669C13.6854 2.66669 11.4656 3.59942 9.82889 5.2597C8.19221 6.91998 7.27273 9.17181 7.27273 11.5198V13.7331C7.24594 14.4081 7.08225 15.0703 6.79188 15.6782C6.50151 16.2862 6.09069 16.8269 5.58509 17.2666C4.67658 18.0519 4.10755 19.167 4 20.3729C4 23.1395 8.48582 24.7995 16 24.7995C23.5142 24.7995 28 23.1395 28 20.3729C27.8925 19.167 27.3234 18.0519 26.4149 17.2666C25.9093 16.8269 25.4985 16.2862 25.2081 15.6782C24.9178 15.0703 24.7541 14.4081 24.7273 13.7331Z" fill="#00AEEF"/>
            <path d="M12.8855 27.0127C13.0934 27.6856 13.5076 28.2735 14.0678 28.6909C14.628 29.1083 15.3049 29.3334 16 29.3334C16.6951 29.3334 17.372 29.1083 17.9322 28.6909C18.4924 28.2735 18.9066 27.6856 19.1146 27.0127C18.1393 27.0858 17.1029 27.1234 16 27.1234C14.8971 27.1234 13.8607 27.088 12.8855 27.0127Z" fill="#00AEEF"/>
          </svg>
          <span className="badge bg-danger rounded-pill">
            {unreadNotification}
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu notification-dropdown-menu">
          <div
            className={`notification-dropdown on-click-show-div ${
              notificationDropDown ? "active" : ""
            }`}
            onMouseLeave={handleMouseLeaveAll}
          >
            <>
              <div className="notification-header-title p-l--xs d-flex align-items-center justify-content-between">
                {translate("general.notification.title")}
                <div>
                  <span style={{ fontWeight: 400 }}>
                    {translate("general.notification.unread")}
                  </span>
                  <Switch
                    checked={showUnread}
                    style={{
                      marginLeft: "8px",
                      marginRight: "16px",
                    }}
                    size="small"
                    onChange={handleChangeUnreadSwitch}
                  />
                </div>
              </div>
              <hr style={{ margin: 0 }} />
              <div className="notifications-content">
                <InfiniteScroll
                  dataLength={notifications.length}
                  next={handleInfiniteOnLoad}
                  hasMore={true}
                  height={500}
                  loader={loadingNotification && notifications.length > 5}
                >
                  {
                    <div className="notifications d-flex flex-column align-item-center">
                      {notifications &&
                        notifications?.length > 0 &&
                        notifications?.map((notification, index) => (
                          <div
                            key={index}
                            onMouseEnter={() =>
                              handleMouseEnterNotification(notification)
                            }
                            onMouseLeave={() =>
                              handleMouseLeaveNotification(notification)
                            }
                          >
                            <div className="box-notification-wrapper">
                              <div
                                onClick={handleReadNotification(
                                  notification.id,
                                  notification.linkWebsite
                                    ? `${buildAbsoluteLink(
                                      notification.linkWebsite
                                    )}`
                                    : "#"
                                )}
                                className={classNames(
                                  "box-notification align-items-center",
                                  {
                                    "box-notification-unread":
                                      notification.unread === true,
                                  }
                                )}
                              >
                                <div className="box-notification-content justify-content-between d-flex m-b--xxxs">
                                  <div className="box-notification-content-left p-l--md p-t--xs">
                                    <div className="box-notification-text-first-row">
                                      {notification?.titleWeb}
                                    </div>
                                    <div className="box-notification-text-second-row m-l--xxxs">
                                      {formatDateTimeFromNow(
                                        notification?.time,
                                        "vi"
                                      )}
                                    </div>
                                    <div className="box-notification-content-content p-b--xs p-t--xxxs p-r--xs text-truncate--3">
                                      {notification?.contentWeb}
                                    </div>
                                  </div>

                                  {!(
                                    notification.unread === true ||
                                    notification.isHover === false ||
                                    notification.isHover === undefined
                                  ) && (
                                    <div className="box-notification-content-right d-flex">
                                      {
                                        <EmailNew16
                                          className="box-notification-header-icon"
                                          onClick={(event) =>
                                            handleUnReadNotification(
                                              event,
                                              notification
                                            )
                                          }
                                        />
                                      }
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      {!hasMore && (
                        <div
                          className="d-flex justify-content-center p-2"
                          style={{ background: "#e8e8e8", fontSize: 12 }}
                        >
                          {translate("general.notification.listAllLeft")}
                          <b>&nbsp;{total}&nbsp;</b>
                          {translate("general.notification.listAllRight")}
                        </div>
                      )}
                    </div>
                  }
                </InfiniteScroll>
              </div>
            </>
            <div className="border-top d-grid">
              {!notifications?.length &&
                !loadingNotification &&
                notificationDropDown && (
                  <div className="d-flex justify-content-center">
                    <div className="no-data-item">
                      {translate("general.notification.noData")}
                    </div>
                  </div>
                )}
              {notificationDropDown && (
                <div className="notification-footer text-left justify-content-between d-flex">
                  <Button
                    type="ghost"
                    className="d-flex notification-footer-view-all"
                    onClick={handleClickToNotification}
                  >
                    {translate("general.notification.viewAll")}
                    <Launch16 className="m-l--xxxs" />
                  </Button>

                  <Button
                    type="ghost"
                    className="notification-footer-read-all p-l--md p-r--md"
                    onClick={handleClickReadAllNotification}
                  >
                    <Email24 />
                  </Button>
                </div>
              )}
            </div>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};
